import { useRef } from "react";
import { Transition } from "react-transition-group";
import useCommonHelper from "../../../hooks/helper.hook";
import useDropdown from "../../../hooks/dropdown-item.hook";
import { cn } from "../../../lib/utils";

function Content({ children, right, className }) {
	const { isOpen, handleToggle } = useDropdown();

	const renderChild =
		typeof children === "function" ? children({ isOpen, closeDropDown: handleToggle }) : children;

	const { animationClass } = useCommonHelper();

	const popoverContent = useRef(null);

	return (
		<Transition
			nodeRef={popoverContent}
			in={isOpen}
			mountOnEnter
			unmountOnExit
			timeout={{ enter: 200, exit: 200 }}
		>
			{(state) => (
				<div
					ref={popoverContent}
					className={cn(
						"main_comp_dropdow_content",
						right && "right_ancor",
						animationClass(state, "popover_in", "popover_out"),
						className
					)}
				>
					{renderChild}
				</div>
			)}
		</Transition>
	);
}

export default Content;
